module.exports = __webpack_public_path__ + "img/role03.87cc38a7.png";